import { cn } from '../../lib/cn';
import { ChevronLeft } from 'lucide-react';
import { IconButton } from '../design-system/IconButton';
import { useNavigate } from 'react-router-dom';

interface ScreenShellProps {
  children: React.ReactNode;
  title?: string;
  showBack?: boolean;
  onBack?: () => void;
  headerSlot?: React.ReactNode;
  bottomSlot?: React.ReactNode;
  className?: string;
  scrollable?: boolean;
}

export function ScreenShell({
  children,
  title,
  showBack = false,
  onBack,
  headerSlot,
  bottomSlot,
  className,
  scrollable = true,
}: ScreenShellProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={cn('flex h-full flex-col bg-slate-50 dark:bg-slate-900', className)}>
      {(showBack || title) && (
        <header className="flex h-14 shrink-0 items-center gap-2 border-b border-slate-100 bg-white px-2 dark:border-slate-800 dark:bg-slate-800">
          {showBack && (
            <IconButton
              icon={<ChevronLeft className="h-6 w-6" />}
              label="Back"
              variant="ghost"
              size="md"
              onClick={handleBack}
            />
          )}
          {title && (
            <h1 className="text-base font-semibold text-slate-900 dark:text-slate-50">
              {title}
            </h1>
          )}
        </header>
      )}

      {headerSlot && <div className="shrink-0">{headerSlot}</div>}

      <main className={cn('flex-1 overflow-y-auto', scrollable && 'scroll-smooth')}>
        {children}
      </main>

      {bottomSlot && <div className="shrink-0">{bottomSlot}</div>}
    </div>
  );
}
